// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PlatformReadyState {
}

export function getIsPlatformReady(store: PlatformReadyState): boolean {
	return true
}